/**
 * Converts a file size in bytes to a human-readable string with appropriate units.
 * This function automatically decides between Bytes, KB, and MB.
 *
 * @param {number} size - The file size in bytes.
 * @returns {string|undefined} The formatted file size with units, as a string.
 *                             Returns `undefined` if the input is not a finite number.
 * @example
 * getFormattedFileSize(1024); // "1 KB"
 * getFormattedFileSize(1234); // "1.2 KB"
 * getFormattedFileSize(1048576); // "1.0 MB"
 */
export function getFormattedFileSize(size) {
    if (!Number.isFinite(size)) return undefined;

    const sizeTypes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(size) / Math.log(1024));
    let computedSize = size / (1024 ** i);

    if (i === 0) {
        computedSize = Math.round(computedSize);
    } else if (i === 1) {
        if (computedSize < 100) {
            computedSize = (Math.round(computedSize * 10) / 10).toFixed(1);
        } else {
            computedSize = Math.round(computedSize);
        }
    } else if (i === 2) {
        computedSize = (Math.round(computedSize * 10) / 10).toFixed(1);
    }

    return `${computedSize} ${sizeTypes[i]}`;
}
